function getGlobalThis() {
  return globalThis;
}
export {
  getGlobalThis
};
//# sourceMappingURL=GetGlobalThis.js.map
